import { Card, CardBody, Col, Row } from 'reactstrap';

const NoData = ({ customMessage }: { customMessage?: string }) => {
  return (
    <Row>
      <Col>
    <Card className="mt-6 mt-lg-4  no-data">
      <CardBody className="d-flex align-items-center no-data">
        <strong>{customMessage || 'No data found!'}</strong>
      </CardBody>
    </Card>
    </Col>
    </Row>
  );
};

export default NoData;
